import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PButtonModule } from '@panaya/ui/p-button';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PBackToListButtonComponent } from './p-back-to-list-button.component';

@NgModule({
    declarations: [PBackToListButtonComponent],
    imports: [CommonModule, TranslateModule, PButtonModule, MatTooltipModule],
    exports: [PBackToListButtonComponent]
})
export class PBackToListButtonModule {}
